import { useState, useEffect, useRef } from 'react';
import { monedaService } from '../../services/api/moneda.service';
import type { Moneda } from './monedas';

export function useMonedas(): Moneda[] {
  const [monedas, setMonedas] = useState<Moneda[]>([]);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;
    monedaService.getAll().then((res) => {
      if (res.data) setMonedas(res.data);
    }).catch(() => {});
  }, []);

  return monedas;
}
